module.exports = __webpack_public_path__ + "media/images/gallery/constellations/border_layer_off-e2a16c772d3a5a9f515ecd2132c44b6e.png";